const cnt = {
  min_time_needed: 0 * 60, // 0 minutes
  default_notes_color: '#FFC921',
  colors: {
    grey: '#AFBCCF',
    red: '#FF4A8E',
    orange: '#FEA783',
    rind: '#FFC921',
    yellow: '#FFF53C',
    green: '#D1EC26',
    cyan: '#96D7D5',
    blue: '#34AED7',
    purple: '#B360D4',
    white: '#E6E6E6',
  },
  methods: {
    user_interviews: 'User Interviews',
    user_testing: 'User Testing',
    focus_group: 'Focus Group',
    mixed_methods: 'Mixed Methods',
  },
  notesColors: {
    quotes: '#34AED733', // rgba(52, 174, 215, 0.20)
    needs: '#FFC92133', // rgba(255, 201, 33, 0.20)
    qas: '#40424A33', // rgba(64, 66, 74, 0.20)
    feedback: {
      positive: '#1FB91233', // rgba(31, 185, 18, 0.20)
      negative: '#D4081433', // rgba(212, 8, 20, 0.20)
      neutral: '#FFF53C33', // rgba(255, 245, 60, 0.20)
    },
  },
}

export default cnt
